const barGroup = (() => {
	/**
	 * init : initializing bar group chart
	 *
	 * @author Nitesh <nitesh.meena@biz2credit.com>
	 *
	 * @param config object
	 */
	const init = (config) => {
		const bars = Object.keys(config.color.bars), colors = [], container = d3.select(config.id),
			{ width, height, margin, bar_padding, axis_ticks } = config,
			svg = container.append("svg").attr("width", width).attr("height", height).append("g").attr("transform", `translate(${margin.left}, ${margin.top})`);
		for (let i = 0; i < bars.length; ++i) colors.push(config.color.bars[bars[i]]);
		const is_doller_format = config.is_doller_format || false;
		let old_data = [];
		Object.assign(old_data, config.data);
		const x_scale_0 = d3.scaleBand().range([0, width - margin.left - margin.right]).padding(bar_padding),
			x_axis = d3.axisBottom(x_scale_0).tickFormat(function (d) {
				const date = d.toString().split("-");
				return date[0] + "-" + date[1] % 100;
			}).tickSizeOuter(axis_ticks.outer_size),
			y_scale = d3.scaleLinear().range([height - margin.top - margin.bottom, 0]),
			y_axis = d3.axisLeft(y_scale);
		if (config.max_y_axis > 0) y_axis.ticks(5);
		else y_axis.tickValues([0, 100]);

		if (!!config.tick_values) y_axis.tickValues(config.tick_values);

		y_axis.tickFormat(d => is_doller_format ? initScript.separateNumberByDelimiter(d / 1000) : Math.trunc(d)).tickSizeOuter(axis_ticks.outerSize);
		let x_scale_1 = d3.scaleBand();

		x_scale_0.domain(config.data.map(d => d[config.x_axis]));
		x_scale_1.domain(bars).range([0, x_scale_0.bandwidth()]);
		y_scale.domain([0, config.max_y_axis + 1]);

		const graph = svg.selectAll("." + config.x_axis)
			.data(config.data)
			.enter()
			.append("g")
			.attr("class", config.x_axis)
			.attr("transform", d => `translate(${x_scale_0(d[config.x_axis])} , 0)`);
		for (let i = 0; i < bars.length; ++i) {
			graph
				.selectAll(".bar." + bars[i]).data(d => [d])
				.enter()
				.append("rect")
				.attr("rx", 5)
				.attr("ry", 3)
				.attr("class", "bar " + bars[i])
				.attr("width", 6)
				.on("mouseover", function (d, j) {
					const tooltip_value = (d[bars[i] + "_is_neg"] ? -1 : 1) * d[bars[i]];
					tooltipSection.transition()
						.duration(200)
						.style("opacity", .9);
					tooltipSection.html(is_doller_format ? initScript.separateNumberByDelimiter(tooltip_value / 1000) : tooltip_value)
						.style("left", (d3.event.pageX + config.tooltip.left - (config.tooltip.diff ? (+initScript.getHTMLElementByDelimiter("hideShowSection1 .col-6").width() - +initScript.getHTMLElementByDelimiter("graph").width()) : 0)) + "px")
						// .style("top", (height - margin.top + margin.bottom - +d3.select(this).attr("height") + +config.tooltip.top) + "px")
						.style("top", (d3.event.pageY-120)+"px")
						.style("display", "block")
						.style("color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
						.style("border-color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
						.append("span")
						.style("border-color", d[bars[i] + "_is_neg"] ? "red" : colors[i])
				})
				.on("mouseout", function (d) {
					tooltipSection.html(" ")
						.style("display", "none");
				})
				.style("fill", d => config.color.bars[bars[i]])
				.attr("x", d => x_scale_1(bars[i]))
				.attr("y", d => y_scale(0))
				.attr("height", d =>  height - margin.top - margin.bottom - y_scale(0))
				.attr("y", d => y_scale(0))
				.attr("height", d => height - margin.top - margin.bottom - y_scale(0))
		}

		for (let i = 0; i < bars.length; ++i) {
			graph
				.selectAll(".bar." + bars[i]).data(d => [d])
				.transition()
				.duration(1200)
				.delay(200)
				.style("fill", d => config.color.bars[bars[i]])
				.attr("width", (config.barWidth)?x_scale_0.bandwidth():6)
				.attr("y", d => y_scale(d[bars[i]]))
				.attr("height", d => height - margin.top - margin.bottom - y_scale(d[bars[i]] || 0))
				
		}
		
		if(config.isLine){
			var line = d3.line()
			// console.log(config.id)
			let lines = svg.append("path")
			.datum(config.lineData)
			.attr("fill", "none")
			.attr("stroke", config.color.bars["field3"])
			.attr("stroke-width", 3)
			.attr("d", line
			.x(function(d) { 
				return x_scale_0(d.model_name) })
			.y(function(d) { return y_scale((d.field3<0)?0:d.field3) })
			);

			svg.selectAll("circle-group")
			.data(config.lineData).enter()
			.append("g")

			.style("fill", config.color.bars["field3"])
			
			.selectAll("circle")
			.data(config.lineData).enter()
			.append("g")
			.style("cursor", "pointer")
			.attr("class", "circle")
			.on("mouseover", function (d, i) {
				tooltipSection.html(initScript.separateNumberByDelimiter(d.field3 / 1000));
				tooltipSection
					.style("left", (d3.event.pageX + config.tooltip.left - (config.tooltip.diff ? (+initScript.getHTMLElementByDelimiter("hideShowSection1 .col-6").width() - +initScript.getHTMLElementByDelimiter("graph").width()) : 0)) + "px")
					.style("top", (d3.event.pageY-120)+"px")//(height - margin.top + margin.bottom - +d3.event.pageY + +config.tooltip.top) + "px")
					.style("position", "absolute")
					.style('display', 'block')
					.style('color', config.color.bars["field3"])
					.style('font-weight', 'bold')
					.style('border-color', config.color.bars["field3"])
					.style('opacity', 0.7)
					.append("span")
					.style("border-color", config.color.bars["field3"]);
			})
			.on("mouseout", function (d) {
				tooltipSection.style('display', 'none')
			})

			.append("circle")
			.attr("cx", d => {
				// console.log(d);
				return x_scale_0(d.model_name)})
			.attr("cy", d => y_scale((d.field3<0)?0:d.field3))	

			.attr("r", 5)
			.style('opacity', 1)
			// .on("mouseout", function (d) {
			// 	d3.select(this)
			// 		.transition()
			// 		.duration(1000)
			// 		.attr("r", 5);
			// });
		}

		svg.append("g").attr("class", "x axis").attr("transform", `translate(0, ${height - margin.top - margin.bottom})`).call(x_axis);
		svg.append("g").attr("class", "y axis").call(y_axis);
		const tooltipSection = d3.select("body").append("div")
			.attr("class", "tooltip")
			.style("opacity", 0);
	};
	return {
		init,
	};
})();
